/** Пути к общим SVG-иконкам в `public/`. */
export const COMMON_ICONS = {
    chevronRight: "/icons/common/chevron-right.svg",
    chevronDown: "/icons/common/chevron-down.svg",
    search: "/images/common/loupe.svg",
    crossInCircle: "/images/common/cross_in_circle.svg",
    reset: "/images/common/cross_in_circle.svg",
    moreHoriz: "/images/common/more_horiz.svg",
} as const;
